import React, {useState, useMemo} from 'react';
import {useTranslation} from "react-i18next";
import {withRouter, useRouteMatch} from 'react-router-dom';
import MetisMenu from 'react-metismenu';
import {connect} from "react-redux";
import cx from 'classnames';
import {Button} from "reactstrap";
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {buildStyles, CircularProgressbar} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import moment from 'moment';

import {setEnableMobileMenu} from '../actions/ThemeOptions';
import {setUpgradeToPROModalOpen} from "../actions/Billing";
import {
    CHARGEBEE_SUBSCRIPTION_STATUS_IN_TRIAL,
    METIS_MENU_BILLING,
    METIS_MENU_CUSTOM_PREFIX,
    SHOP_SOURCE_ONE_MESSAGE,
    SHOP_SOURCE_HIGHTOUCH,
    SHOP_SOURCE_RETAIL_CRM_WABA_RU,
    SHOP_SOURCE_RETAIL_CRM_INSTAGRAM_RU,
} from "../constants";
import SimpleChat from "./AppHeader/Components/SimpleChat";
import InstanceModal from "./AppHeader/Components/InstanceModal";


const _ExtendedLinkComponent = (
    {
        className,
        classNameActive,
        classNameHasActiveChild,
        active,
        hasActiveChild,
        to,
        externalLink,
        hasSubMenu,
        toggleSubMenu,
        activateMe,
        children,
        billingConfig,

        setUpgradeToPROModalOpen,
    }
) => {
    const customActivateMe = (event) => {
        /**
         * 1. Для внешних ссылок пункт меню не активируем
         * 2. Для ссылок-функций запускаем эти функции
         * 3. В остальных случаях оставляем стандартное поведение
         */
        if (to && to.startsWith(METIS_MENU_CUSTOM_PREFIX)) {
            switch (to) {
                case METIS_MENU_BILLING:
                    setUpgradeToPROModalOpen(true);
                    break;
            }

            event.preventDefault();
            return;
        } else if (externalLink) {
            return;
        }

        return activateMe(event);
    }

    return <a
        className={cx(
            className,
            active && classNameActive,
            hasActiveChild && classNameHasActiveChild,
        )}
        href={to && to.startsWith(METIS_MENU_CUSTOM_PREFIX) ? '#' : to}
        onClick={hasSubMenu ? toggleSubMenu : customActivateMe}
        target={externalLink ? '_blank' : undefined}
    >
        {children}
    </a>;
};

const mapState1ToProps = state => ({});

const mapDispatch1ToProps = dispatch => ({
    setUpgradeToPROModalOpen: open => dispatch(setUpgradeToPROModalOpen(open)),
});

const ExtendedLinkComponent = withRouter(connect(mapState1ToProps, mapDispatch1ToProps)(_ExtendedLinkComponent));


const Nav = (
    {
        user,
        activeShop,
        billingConfig,

        setEnableMobileMenu,
        setUpgradeToPROModalOpen,
    }
) => {
    let [navLinks, setNavLinks] = useState([]);

    const {t, i18n} = useTranslation();

    const isOneMessage = get(activeShop, 'source') === SHOP_SOURCE_ONE_MESSAGE;
    const isRetailCRM = (
        get(activeShop, 'source') === SHOP_SOURCE_RETAIL_CRM_WABA_RU
        || get(activeShop, 'source') === SHOP_SOURCE_RETAIL_CRM_INSTAGRAM_RU
    );
    const activeShopId = get(activeShop, 'id');

    let mainNav;
    let mainNav2;
    mainNav2 = [
        {
            icon: 'pe-7s-chat',
            label: t('layout.vertical_nav.menu.chats', 'Chats'),
            to: `#/${activeShopId}/chats/`,
        },
        {
            icon: 'pe-7s-user',
            label: t('layout.vertical_nav.menu.audience.title', 'Audience'),
            content: [
                {
                    label: t('layout.vertical_nav.menu.audience.users', 'Subscribers'),
                    to: `#/${activeShopId}/audience/bot_users/`,
                },
                {
                    label: t('layout.vertical_nav.menu.audience.groups', 'Groups'),
                    to: `#/${activeShopId}/audience/groups/`,
                },
                {
                    icon: 'pe-7s-note2',
                    label: t('layout.vertical_nav.menu.audience.leads', 'Leads'),
                    to: `#/${activeShopId}/audience/leads/`,
                },
            ]
        },
        {
            icon: 'pe-7s-paper-plane',
            label: t('layout.vertical_nav.menu.broadcasts', 'Broadcasts'),
            to: `#/${activeShopId}/broadcasts/tasks/`,
        },
        {
            icon: 'pe-7s-rocket',
            label: t('layout.vertical_nav.menu.dashboard', 'Dashboard'),
            to: `#/${activeShopId}/dashboard/`,
        },
        {
            icon: 'pe-7s-settings',
            label: t('layout.vertical_nav.menu.settings.title', 'Settings'),
            content: [
                {
                    icon: 'pe-7s-home',
                    label: t('layout.vertical_nav.menu.settings.common', 'Common'),
                    to: `#/${activeShopId}/settings/common/`,
                },
                {
                    icon: 'pe-7s-message',
                    label: t('layout.vertical_nav.menu.settings.live_chat', 'Live chat'),
                    to: `#/${activeShopId}/settings/live_chat/`,
                },
                {
                        icon: 'pe-7s-volume2',
                        label: t('layout.vertical_nav.menu.settings.notifications', 'Notification channels'),
                        to: `#/${activeShopId}/settings/notifications/`,
                    },
                {
                    icon: 'pe-7s-users',
                    label: t('layout.vertical_nav.menu.settings.team', 'Team'),
                    to: `#/${activeShopId}/settings/team/`,
                },
                {
                    icon: 'pe-7s-edit',
                    label: t('layout.vertical_nav.menu.settings.personal_settings', 'Personal settings'),
                    to: `#/${activeShopId}/settings/personal_settings/`,
                }
            ],
        },
        {
            icon: 'pe-7s-help1',
            label: t('layout.vertical_nav.menu.help.title', 'Help'),
            content: [
                {
                    label: t('layout.vertical_nav.menu.help.knowledge_base', 'Knowledge base'),
                    to: `https://bot-docs-en.1msg.io/`,
                    externalLink: true,
                },
                {
                    label: t('layout.vertical_nav.menu.help.api_docs', 'API - docs'),
                    to: `https://help.1msg.io/ru/vizual_nyj_konstruktor_chat_botov/obwie_svedeniya`,
                    externalLink: true,
                },
                {
                    label: t('layout.vertical_nav.menu.help.support_whatsapp', 'Support via WhatsApp'),
                    to: `https://api.whatsapp.com/send?phone=15855721186&text=Hi%2C%20I%20have%20a%20question%20about%20the%20bot%20builder`,
                    externalLink: true,
                },
            ]
        },
    ];
    if (isRetailCRM) {
        mainNav = [
            {
                icon: 'pe-7s-rocket',
                label: t('layout.vertical_nav.menu.dashboard', 'Dashboard'),
                to: `#/${activeShopId}/dashboard/`,
            },
            {
                icon: 'pe-7s-chat',
                label: t('layout.vertical_nav.menu.settings.hsm_templates', 'WABA-templates'),
                to: `#/${activeShopId}/settings/waba_templates/`,
            },
            {
                icon: 'pe-7s-help1',
                label: t('layout.vertical_nav.menu.help.support_whatsapp', 'Support via WhatsApp'),
                to: `https://api.whatsapp.com/send?phone=15855721186&text=Hi%2C%20I%20have%20a%20question%20about%20the%20bot%20builder`,
                externalLink: true,
            },
        ];
    } else {
        mainNav = [
            {
                icon: 'pe-7s-rocket',
                label: t('layout.vertical_nav.menu.dashboard', 'Dashboard'),
                to: `#/${activeShopId}/dashboard/`,
            },
            {
                icon: 'pe-7s-user',
                label: t('layout.vertical_nav.menu.audience.title', 'Audience'),
                content: [
                    {
                        label: t('layout.vertical_nav.menu.audience.users', 'Subscribers'),
                        to: `#/${activeShopId}/audience/bot_users/`,
                    },
                    {
                        label: t('layout.vertical_nav.menu.audience.groups', 'Groups'),
                        to: `#/${activeShopId}/audience/groups/`,
                    },
                    {
                        icon: 'pe-7s-note2',
                        label: t('layout.vertical_nav.menu.audience.leads', 'Leads'),
                        to: `#/${activeShopId}/audience/leads/`,
                    },
                ]
            },
            {
                icon: 'pe-7s-chat',
                label: t('layout.vertical_nav.menu.chats', 'Chats'),
                to: `#/${activeShopId}/chats/`,
            },
            {
                icon: 'pe-7s-magnet',
                label: t('layout.vertical_nav.menu.growth.title', 'Growth Tools'),
                content: [
                    {
                        label: t('layout.vertical_nav.menu.growth.chat_links', 'Short URLs'),
                        to: `#/${activeShopId}/growth/short_links/`,
                    },
                    {
                        label: t('layout.vertical_nav.menu.growth.website_icon_link', 'Website icon link'),
                        to: `#/${activeShopId}/growth/website_icon_links/`,
                    },
                ],
            },
            {
                icon: 'pe-7s-paper-plane',
                label: t('layout.vertical_nav.menu.broadcasts', 'Broadcasts'),
                to: `#/${activeShopId}/broadcasts/tasks/`,
            },
            // {
            //     icon: 'pe-7s-plugin',
            //     label: t('layout.vertical_nav.menu.automation.title', 'Automation'),
            //     content: [
            {
                icon: 'pe-7s-plugin',
                label: t('layout.vertical_nav.menu.automation.keywords', 'Keywords'),
                to: `#/${activeShopId}/automation/keywords/`,
            },
            // {
            //     label: t('layout.vertical_nav.menu.automation.triggers', 'Triggers'),
            //     to: `#/${activeShopId}/automation/triggers/`,
            // },
            //     ],
            // },
            {
                icon: 'pe-7s-share',
                label: t('layout.vertical_nav.menu.flow_builder', 'Flow builder'),
                to: `#/${activeShopId}/flows/`,
            },
            // {
            //     icon: 'pe-7s-network',
            //     label: t('layout.vertical_nav.menu.steps', 'Steps'),
            //     to: `#/${activeShopId}/steps/steps/`,
            // },
            {
                icon: 'pe-7s-cart',
                label: t('layout.vertical_nav.menu.shop.title', 'Shop'),
                content: [
                    {
                        label: t('layout.vertical_nav.menu.shop.categories', 'Categories'),
                        to: `#/${activeShopId}/catalog/categories/`,
                    },
                    {
                        icon: 'pe-7s-bicycle',
                        label: t('layout.vertical_nav.menu.shop.products', 'Products'),
                        to: `#/${activeShopId}/catalog/products/`,
                    },
                    {
                        icon: 'pe-7s-credit',
                        label: t('layout.vertical_nav.menu.shop.orders', 'Orders'),
                        to: `#/${activeShopId}/catalog/orders/`,
                    },
                ],
            },
            {
                icon: 'pe-7s-settings',
                label: t('layout.vertical_nav.menu.settings.title', 'Settings'),
                content: [
                    {
                        icon: 'pe-7s-home',
                        label: t('layout.vertical_nav.menu.settings.common', 'Common'),
                        to: `#/${activeShopId}/settings/common/`,
                    },
                    {
                        icon: 'pe-7s-message',
                        label: t('layout.vertical_nav.menu.settings.live_chat', 'Live chat'),
                        to: `#/${activeShopId}/settings/live_chat/`,
                    },
                    {
                        icon: 'pe-7s-diskette',
                        label: t('layout.vertical_nav.menu.settings.custom_fields', 'Custom fields'),
                        to: `#/${activeShopId}/settings/custom_fields/`,
                    },
                    {
                        icon: 'pe-7s-ticket',
                        label: t('layout.vertical_nav.menu.settings.tags', 'Tags'),
                        to: `#/${activeShopId}/settings/tags/`,
                    },
                    {
                        icon: 'pe-7s-volume2',
                        label: t('layout.vertical_nav.menu.settings.notifications', 'Notification channels'),
                        to: `#/${activeShopId}/settings/notifications/`,
                    },
                    {
                        icon: 'pe-7s-card',
                        label: t('layout.vertical_nav.menu.settings.payments', 'In bot payments'),
                        to: `#/${activeShopId}/settings/payment_gates/`,
                    },
                    {
                        icon: 'pe-7s-chat',
                        label: t('layout.vertical_nav.menu.settings.hsm_templates', 'WABA-templates'),
                        to: `#/${activeShopId}/settings/waba_templates/`,
                    },
                    {
                        icon: 'pe-7s-users',
                        label: t('layout.vertical_nav.menu.settings.team', 'Team'),
                        to: `#/${activeShopId}/settings/team/`,
                    },
                    // TODO @blademor - вернуть потом
                    // {
                    //     label: t('layout.vertical_nav.menu.settings.billing', 'Billing'),
                    //     to: METIS_MENU_BILLING,
                    // },
                    {
                        icon: 'pe-7s-tools',
                        label: t('layout.vertical_nav.menu.settings.integrations', 'Integrations'),
                        to: `#/${activeShopId}/settings/plugins/`,
                    },
                    {
                        icon: 'pe-7s-edit',
                        label: t('layout.vertical_nav.menu.settings.personal_settings', 'Personal settings'),
                        to: `#/${activeShopId}/settings/personal_settings/`,
                    }
                ],
            },
            {
                icon: 'pe-7s-help1',
                label: t('layout.vertical_nav.menu.help.title', 'Help'),
                content: [
                    {
                        label: t('layout.vertical_nav.menu.help.knowledge_base', 'Knowledge base'),
                        to: `https://bot-docs-en.1msg.io/`,
                        externalLink: true,
                    },
                    {
                        label: t('layout.vertical_nav.menu.help.api_docs', 'API - docs'),
                        to: `https://help.1msg.io/ru/vizual_nyj_konstruktor_chat_botov/obwie_svedeniya`,
                        externalLink: true,
                    },
                    {
                        label: t('layout.vertical_nav.menu.help.support_whatsapp', 'Support via WhatsApp'),
                        to: `https://api.whatsapp.com/send?phone=15855721186&text=Hi%2C%20I%20have%20a%20question%20about%20the%20bot%20builder`,
                        externalLink: true,
                    },
                ]
            },
        ];
    }

    // Trial period
    let billingBlock = undefined;
    if (!isEmpty(billingConfig)
        && activeShop.source === SHOP_SOURCE_HIGHTOUCH
        && billingConfig.subscription.status === CHARGEBEE_SUBSCRIPTION_STATUS_IN_TRIAL
    ) {
        const currentTs = moment().unix();
        const trialStart = billingConfig.subscription.trial_start;
        const trialEnd = billingConfig.subscription.trial_end;
        const percentage = 100 * (currentTs - trialStart) / (trialEnd - trialStart);
        billingBlock = <div className='pb-3 pt-4 menu-upgrade-button'>
            <div className="border-top d-flex justify-content-start align-items-center py-2">
                <div className='p-2'
                     style={{
                         width: '80px',
                     }}
                >
                    <CircularProgressbar
                        value={percentage}
                        strokeWidth={16}
                        text={moment.unix(trialEnd).diff(moment(), "days")}
                        styles={buildStyles({
                            pathColor: '#0ecb6b',
                            trailColor: '#d7dbe5',
                            textColor: 'black',
                            textSize: 36,
                        })}
                    />
                </div>
                <div>
                    <small>{t('layout.vertical_nav.trial_notification_title', 'Days left until the end of the trial period')}</small>
                </div>
            </div>
            <Button
                size="lg"
                color="primary"
                className="w-100"
                onClick={e => setUpgradeToPROModalOpen(true)}
            >
                {t('layout.vertical_nav.button_become_pro', 'Upgrade to PRO')}
            </Button>
        </div>
    }

    let activeLocation = useRouteMatch();

    return <>
        {!activeShop.simple_chat && useMemo(() => <MetisMenu
            content={mainNav}
            activeLinkTo={`#${activeLocation.url}${activeLocation.url.substr(-1) !== '/' ? '/' : ''}`}
            className="vertical-nav-menu mt-4"
            iconNamePrefix=""
            classNameStateIcon="pe-7s-angle-down"
            LinkComponent={ExtendedLinkComponent}
            onSelected={() => setEnableMobileMenu(false)}
        />, [activeShop.simple_chat])}
        {activeShop.simple_chat && useMemo(() => <MetisMenu
            content={mainNav2}
            activeLinkTo={`#${activeLocation.url}${activeLocation.url.substr(-1) !== '/' ? '/' : ''}`}
            className="vertical-nav-menu mt-4"
            iconNamePrefix=""
            classNameStateIcon="pe-7s-angle-down"
            LinkComponent={ExtendedLinkComponent}
            onSelected={() => setEnableMobileMenu(false)}
        />, [activeShop.simple_chat])}

         <InstanceModal/>
        {isOneMessage && <SimpleChat/>}

        {/*{billingBlock}*/}
    </>;
}


const mapStateToProps = state => ({
    user: state.Auth.user,
    activeShop: state.Shops.activeShop,
    billingConfig: state.Billing.billingConfig,
});

const mapDispatchToProps = dispatch => ({
    setEnableMobileMenu: enable => dispatch(setEnableMobileMenu(enable)),
    setUpgradeToPROModalOpen: open => dispatch(setUpgradeToPROModalOpen(open)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Nav));
